import {Inject, Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApi, BASE_URL } from '@edl-development/edl-common';
import { PortalModules } from '../model/portal-modules.model';

@Injectable()
export class PaetepPortalApi extends BaseApi {
    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    getPortalModuleSettings() {
        return this.http.get<PortalModules>(this.baseUri + '/portal/GetModuleSettings', {});
    }
}
